<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2016</span></div>
    </div>
    <div class="view-wrap yr2016">


<FullYearStats fullGames='16' fullCompletions='471' fullAttempts='673' fullYards='5,208' fullPct='70.0' fullTDs='37' fullINTs='15' fullYPG='325.5' fullRating='101.7'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    

      <div class="year-summary-text-flex">

      <h1 class="content-headline">Another 5,000-yard season</h1>

      <div class="copy-paragraph">
       In 2016, Brees completed 471-of-673 passes (70.0%) for 5,208 yards, 37 touchdowns and a 101.7 rating with 15 interceptions over 16 starts.<br/><br/> 

      Reaching 5,000 passing yards for an NFL-record fifth time in 2016, the passing yardage total marked the second-highest of his career and the fourth-highest all-time. He also set an NFL single-season record for completions, surpassing his previous record of 468 set in 2011.<br/><br/>

      Brees led or tied for the league lead in passing yardage for an NFL-record seventh time, while he ranked first in the NFL in completions, passing yardage and attempts, second in completion percentage, third in touchdown passes and fifth in passer rating and third-down passer rating (107.9). 2016 became his ninth-consecutive season with at least 30 touchdowns, extending his NFL record.<br/><br/>

      Brees was the lone Pro Bowler for the Saints in 2016, as the problems from the past two seasons presented themselves once more. The Saints couldn’t overcome a poor defense and an 0-3 start, finishing 7-9 for the third straight season. Of the nine loss, seven were by six or less points.
      <br/><br/>
      
      Through 2016, Brees’ record as a starter for the Saints was 101-73 (.580) in the regular season and 6-4 (.600) in the postseason, easily making him the winningest signal-caller in all-time franchise history.<br/><br/>



            </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2016-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees throwing over an inside rush by the Tampa Buccaneers">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2016 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2016 Pro Bowl</li>  
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
    </div>
  </div>


<div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2016 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
</div>

<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2016 Touchdown Tally"> 2016 TOUCHDOWN TALLY</h1>
</div>






</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2016 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2016 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2016 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2016 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2016 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2016 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2016 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2016 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2015">«2015</router-link></div>
  <div class="year-pagination-section year-pagination-current">2016</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2017">2017»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2016',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2016 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2016-top.jpg",
      image1: "brees-2016-slide-1.jpg",
      image2: "brees-2016-slide-2.jpg",
      image3: "brees-2016-slide-3.jpg",
      image4: "brees-2016-slide-4.jpg",
      image5: "brees-2016-slide-5.jpg",
      image6: "brees-2016-slide-6.jpg",
      image7: "brees-2016-slide-7.jpg",
      image8: "brees-2016-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2016;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 70.0,
                  y: 325.5,
                  r: 37/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 67.4,
                  y: 296.2,
                  r: 28/1.5
                }
              ]
      },
      {
        "label": "Matt Ryan",
        "backgroundColor": "#A71930",
        "borderColor": "#000000",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 69.9,
                  y: 309.0,
                  r: 38/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.7,
                  y: 276.8,
                  r: 40/1.5
                }
              ]
      },
       {
        "label": "Andrew Luck",
        "backgroundColor": "#FFFFFF",
        "borderColor": "#002C5F",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 63.5,
                  y: 282.7,
                  r: 31/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 5,
                right: 30,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards Per Game, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards Per Game'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2016.vue